import { PROTECTION_TRIGGER_CATALOG, } from './catalog';
export function resolveEffectiveTriggers(input) {
    const minimums = parseMinimums(input.tenantMinimums);
    const playbookConfig = parsePlaybookTriggers(input.playbookTriggers);
    const out = {};
    for (const def of PROTECTION_TRIGGER_CATALOG) {
        const entry = playbookConfig.get(def.id);
        const params = resolveParams(def.id, entry?.params);
        if (def.platformFloor) {
            out[def.id] = { id: def.id, enabled: true, source: 'platform-floor', locked: true, params };
            continue;
        }
        if (minimums.has(def.id)) {
            out[def.id] = { id: def.id, enabled: true, source: 'tenant-minimum', locked: true, params };
            continue;
        }
        if (entry !== undefined) {
            out[def.id] = {
                id: def.id,
                enabled: entry.enabled,
                source: 'playbook',
                locked: false,
                params,
            };
            continue;
        }
        out[def.id] = {
            id: def.id,
            enabled: def.defaultEnabled,
            source: 'default',
            locked: false,
            params,
        };
    }
    return out;
}
/** `true` quando TODAS as viradas estão OFF no efetivo (gate grosso: pular o transition-agent). */
export function allTransitionTriggersDisabled(effective) {
    return PROTECTION_TRIGGER_CATALOG.filter((t) => t.kind === 'virada').every((t) => !effective[t.id].enabled);
}
function parseMinimums(raw) {
    if (!Array.isArray(raw))
        return new Set();
    return new Set(raw.filter((item) => typeof item === 'string'));
}
/**
 * Aceita o shape ratificado `{ version, hard: {id: {enabled, params?}}, transition: {id: {enabled}} }`.
 * Entradas malformadas ou de id desconhecido são descartadas individualmente.
 */
function parsePlaybookTriggers(raw) {
    const out = new Map();
    if (typeof raw !== 'object' || raw === null || Array.isArray(raw))
        return out;
    for (const section of ['hard', 'transition']) {
        const block = raw[section];
        if (typeof block !== 'object' || block === null || Array.isArray(block))
            continue;
        for (const [id, value] of Object.entries(block)) {
            const def = PROTECTION_TRIGGER_CATALOG.find((t) => t.id === id);
            if (def === undefined)
                continue;
            // Seção precisa casar com o kind (hard=dura / transition=virada).
            if ((section === 'hard') !== (def.kind === 'dura'))
                continue;
            if (typeof value !== 'object' || value === null)
                continue;
            const enabled = value.enabled;
            if (typeof enabled !== 'boolean')
                continue;
            const params = value.params;
            out.set(id, {
                enabled,
                params: typeof params === 'object' && params !== null && !Array.isArray(params)
                    ? params
                    : undefined,
            });
        }
    }
    return out;
}
/** Extrai param numérico explícito DENTRO do range do catálogo; fora/ausente → null. */
function resolveParams(id, rawParams) {
    const def = PROTECTION_TRIGGER_CATALOG.find((t) => t.id === id);
    const specs = def?.params ?? [];
    let timeoutMinutes = null;
    let maxConsecutiveRejections = null;
    for (const spec of specs) {
        const raw = rawParams?.[spec.key];
        if (typeof raw !== 'number' || !Number.isInteger(raw) || raw < spec.min || raw > spec.max) {
            continue;
        }
        if (spec.key === 'timeoutMinutes')
            timeoutMinutes = raw;
        if (spec.key === 'maxConsecutiveRejections')
            maxConsecutiveRejections = raw;
    }
    return { timeoutMinutes, maxConsecutiveRejections };
}
//# sourceMappingURL=resolve.js.map